import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { Tag } from "components/DesignSystem/Tag/Tag";
import {
  DropdownIndicator,
  TransactionComboboxControl,
} from "components/Transaction/TransactionColumn";
import {
  BOOKS_GLOBAL_STATUSES,
  BOOKS_GLOBAL_STATUS_COMPLETED,
  getBooksGlobalStatusColor,
  isManualBooksGlobalStatus,
} from "constants/booksGlobalStatus";
import { useBooksGlobalStatusUpdate } from "hooks/useBooksGlobalStatusUpdate";
import { MultiValue, SingleValue } from "react-select";
import { BooksGlobalStatus as BooksGlobalStatusType } from "types/Models/bookkeepingTracker";
import { BooksStatusChangeModal } from "./BooksStatusChangeModal";

const StatusTag = ({ status }: { status: BooksGlobalStatusType }) => (
  <Tag icon={false} tagType={getBooksGlobalStatusColor(status.key)} rounded>
    {status.name}
  </Tag>
);

const toOption = (status: BooksGlobalStatusType) => ({
  label: <StatusTag status={status} />,
  value: status.key,
});

const manualOptions = BOOKS_GLOBAL_STATUSES.filter(({ key }) =>
  isManualBooksGlobalStatus(key)
);

export const BooksGlobalStatus = ({
  taskId,
  status,
}: {
  taskId: string;
  status: BooksGlobalStatusType | null;
}) => {
  const statusUpdate = useBooksGlobalStatusUpdate(taskId);
  const isCompleted = status?.key === BOOKS_GLOBAL_STATUS_COMPLETED;

  const onStatusChange = (value?: string | null) => {
    const selected = manualOptions.find(({ key }) => key === value);
    if (selected && selected.key !== status?.key) {
      statusUpdate.requestStatusChange(selected);
    }
  };

  const options = manualOptions
    .filter(({ key }) => key !== status?.key)
    .map(toOption);

  return (
    <div className="t-group t-select-none" onClick={(e) => e.stopPropagation()}>
      <Combobox
        size="small"
        menuPlacement="auto"
        creatable={false}
        isDisabled={isCompleted}
        isLoading={statusUpdate.isUpdating}
        placeholder="-"
        onChange={(prop: SingleValue<OptionData> | MultiValue<OptionData>) =>
          onStatusChange((prop as SingleValue<OptionData>)?.value)
        }
        components={{
          Control: TransactionComboboxControl,
          DropdownIndicator,
          ClearIndicator: () => null,
        }}
        options={options}
        value={status ? toOption(status) : null}
        menuPortalTarget={document.body}
        styles={{
          menu: (base) => ({
            ...base,
            width: 240,
          }),
        }}
      />
      <BooksStatusChangeModal statusUpdate={statusUpdate} />
    </div>
  );
};
